export default {"src":"/_next/static/media/black-north-arrow.9843c1f7.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};